module.exports = __webpack_public_path__ + "img/gs_map.0e35bdf8.png";